module.exports = __webpack_public_path__ + "img/medicamentos.f85ba706.png";